import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getCurrentUser from "./common/GetCurrentUser";
import { sendRequest } from '../ApiRequest';
import { BASE_URL, RAZORPAY_KEY } from '../URL/constants';
import { calculateCartTotal } from '../utils/priceUtils';
// We'll use the action directly without importing a type

const Checkout = ({ formData, onPaymentSuccess }) => {
  const cartItems = useSelector((state) => state.addItem);
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const { isLoggedIn, loggedInUser, loginUser, logoutUser, currentUser } = getCurrentUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const totalAmount = calculateCartTotal(cartItems) * 100;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const clearCartAndRedirect = () => {
    dispatch({ type: 'CLEAR_CART' });
    // Dispatch cart-updated event to update cart count immediately
    window.dispatchEvent(new Event('cart-updated'));
    
    if (onPaymentSuccess) {
      onPaymentSuccess();
    }
    navigate('/');
  };

  const handlePaymentMode = (e) => {
    navigate('/payment', {
      state: {
        formData: formData,
        // onPaymentSuccess: onPaymentSuccess,
      },
    });
    
  }

 

  return (
    <div className="container my-5">
      <button
        className="btn btn-primary w-100"
        onClick={handlePaymentMode}
        disabled={loading}
      >
        {loading ? "Processing..." : "Submit Details"}
      </button>
    </div>
  );
};

export default Checkout;